





































import { Component, Prop, Vue } from 'vue-property-decorator'
import ContractorForm from '@/views/auth/sign-up/ContractorForm.vue'
import ManagerForm from '@/views/auth/sign-up/ManagerForm.vue'
import { currentUserIs, Managers, UserRole } from '@/types/Users'
import { retryDwollaPersonalVerification } from '@/services/users'
import { retryDwollaBusinessVerification } from '@/services/organizations'

@Component({
  components: {
    ContractorForm,
    ManagerForm,
  },
})
export default class RetryVerificationDialog extends Vue {
  @Prop({ default: false }) readonly opened!: boolean

  form: any = {}
  isValid = false
  loading = false

  closeDialog() {
    this.$emit('update:opened', false)
  }

  get userIsManager() {
    return currentUserIs(...Managers)
  }

  get userIsContractor() {
    return currentUserIs(UserRole.Contractor)
  }

  managerFormUpdate(form: any) {
    this.form = form
  }

  contractorFormUpdate(form: any) {
    this.form = form
  }

  async retryVerification() {
    this.loading = true
    try {
      if (this.userIsManager) {
        await retryDwollaBusinessVerification(this.$store, this.form)
      } else if (this.userIsContractor) {
        await retryDwollaPersonalVerification(this.$store, this.form)
      }
    } finally {
      this.loading = false
      this.closeDialog()
    }
  }
}
